export default "__VITE_ASSET__EZmkVQ28__"